
















import { Component, Vue, Prop } from 'vue-property-decorator'
import axios from 'axios'

@Component
export default class WebAppModal extends Vue {
  @Prop({ default: '', required: false })
  url?: string;

  @Prop({ default: () => [], required: false })
  usageData!: Array<any>;

  @Prop({ default: false, required: false })
  appToken!: string;

  @Prop({ default: '', required: false })
  appName: string = '';

  @Prop({ default: 0, required: false })
  reportCount: number = 0;

  @Prop({ default: () => [], required: false })
  saveStates!: Array<any>;

  @Prop({ default: () => [], required: false })
  currentSaveStates!: Array<any>;

  @Prop({ default: () => [], required: false })
  currentSaveTokens!: Array<number>;

  async mounted () {
    this.$root.$on('bv::modal::show', (bvEvent: any, modalId: any) => {
      if (modalId === 'web-app-modal') {
        window.addEventListener('beforeunload', this.handleBeforeUnload)
      }
    })
    this.$root.$on('bv::modal::hide', async (bvEvent: any, modalId: any) => {
      if (modalId === 'web-app-modal') {
        window.removeEventListener('beforeunload', this.handleBeforeUnload)
        this.url = ''
        await this.processStats()
        this.usageData = []
        this.reportCount = 0
      }
    })

    // Add event listener for postMessage from iframe
    window.addEventListener('message', (event: MessageEvent) => {
      const iframe = document.getElementById('web-app-iframe') as HTMLIFrameElement
      if (!iframe || !iframe.contentWindow) {
        // console.error('Iframe not found or contentWindow is not accessible.')
        return
      }
      // if the even is webAppUsage then push the item to usageData
      if (event.data.type === 'webAppUsage') {
        if (event.data && event.data.item) {
          this.usageData.push(event.data.item)
        }
      }

      // if the event is webAppSave then process the saveStates, storing them in the DB
      if (event.data.type === 'webAppSave') {
        this.saveStates = event.data.saveStates || []
        // loop through each saveState and check if the key is already in currentSaveTokens
        // if it is, then POST to ${process.env.VUE_APP_API_HOST || 'http://localhost:3305'}/api/v1/web-apps/slr/saves/${appToken}
        // if its not then PUT to the same endpoint
        this.saveStates.forEach((saveState: any) => {
          if (this.currentSaveTokens.includes(saveState.id) && !saveState.archived) {
            // POST request to save the state
            axios.post(`${process.env.VUE_APP_API_HOST || 'http://localhost:3305'}/api/v1/web-apps/slr/saves/${this.appToken}`, saveState,
              { withCredentials: true, responseType: 'json' })
              .then(response => {
                console.log('Web App Save State POST Response:', response.data)
              })
              .catch(error => {
                console.error('Web App Save State POST Error:', error)
              })
          } else if (this.currentSaveTokens.includes(saveState.id) && saveState.archived) {
            axios.delete(`${process.env.VUE_APP_API_HOST || 'http://localhost:3305'}/api/v1/web-apps/slr/saves/${saveState.id}`,
              { withCredentials: true, responseType: 'json' })
              .then(response => {
                // remove the id from currentSaveTokens
                const index = this.currentSaveTokens.indexOf(saveState.id)
                if (index > -1) {
                  this.currentSaveTokens.splice(index, 1)
                }
              })
              .catch(error => {
                console.error('Web App Save State POST Error:', error)
              })
          } else if (!saveState.archived) {
            // PUT request to update the state
            axios.put(`${process.env.VUE_APP_API_HOST || 'http://localhost:3305'}/api/v1/web-apps/slr/saves/${this.appToken}`, saveState,
              { withCredentials: true, responseType: 'json' })
              .then(async response => {
                saveState.id = response.data.results.id // Update the saveState with the new id from the response
                // remove id from currentSaveTokens
                this.currentSaveTokens.push(response.data.results.id)
                await this.loadContent(true).then(() => {
                  if (iframe && iframe.contentWindow) {
                    iframe.contentWindow.postMessage({
                      type: 'currentSaveStates',
                      saveStates: this.currentSaveStates
                    }, '*')
                  }
                })
              })
              .catch(error => {
                console.error('Web App Save State PUT Error:', error)
              })
          }
        })
      }

      // if the event is slrReady then post a message to the iframe with currentSaveStates
      if (event.data.type === 'slrReady') {
        // post a message to the iframe and pass it the currentSaveStates
        iframe.contentWindow.postMessage({
          type: 'currentSaveStates',
          saveStates: this.currentSaveStates
        }, '*')
      }

      if (event.data.type === 'settingLocaleReady') {
        iframe.contentWindow.postMessage({
          type: 'settingLocale',
          locale: this.$store.getters.getSelectedMarketLocale,
          appToken: this.appToken
        }, '*')
      }
    })
  }

  async loadContent (skipRouting: boolean = false) {
    this.appToken = this.$store.getters.getWebToken as string
    const resp = await axios.get(`web-apps/get-context/${this.appToken}`, { withCredentials: true, responseType: 'json' })
    if (resp.data && resp.data.token) {
      if (!skipRouting) {
        this.appName = resp.data.appName || 'Interactive tool'
        this.url = `${process.env.VUE_APP_API_HOST || 'http://localhost:3305'}/api/v1/web-apps/${this.appToken}/${resp.data.token}/index.html`
      }

      // set the currentSaveStates and currentSaveTokens
      this.currentSaveStates = resp.data.appSaves || []
      // store the key property of each resp.data.appSaves item into currentSaveTokens
      this.currentSaveTokens = resp.data.appSaves.map((item: any) => item.id)
    }
  }

  async processStats () {
    debugger
    if (!this.usageData || this.usageData.length !== 0) {
      // create a new refined usageData array which contains just the id, duration and description properties from each usageData item and exclude items without start and end
      const _refinedUsage = this.usageData
        .filter(item => item.start && item.end && item.type !== 'report')
        .map(item => ({
          key: item.id,
          duration: item.duration,
          description: item.description
        }))

      this.reportCount = this.usageData.filter(item => item.type === 'report').length

      // create object to hold the usage data
      const stats: { pageViewsRaw: Array<any>, pageViews: Array<any>, key: string, title: string, reportCount: number } = { pageViewsRaw: this.usageData, pageViews: _refinedUsage, key: this.appToken, title: this.appName, reportCount: this.reportCount }

      this.$store.dispatch('addEvent', {
        description: 'Web App Stats',
        data: stats,
        title: 'Web App Stats',
        eventType: 16,
        userAgent: navigator.userAgent,
        product: { key: this.$store.getters.getAppProduct },
        market: { key: this.$store.getters.getSelectedMarket }
      })
    }

    // clear this.usageData
    this.usageData = []
  }

  async handleBeforeUnload (e: {
    preventDefault: () => void;
    returnValue: string;
  }) {
    await this.processStats()
    // Prevent the default action and show a confirmation message
    e.preventDefault()
    e.returnValue =
      'Please note that you are leaving the current page. Any configuration will be reset.'
  }

  async beforeDestroy () {
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  }

  preventContextMenu (event: MouseEvent) {
    event.preventDefault()
  }
}
